// Please organize this object
//
// some.identifier.organized.by.component: {
//    fr: 'French translation',
//    en: 'English translation',
// }
// Note that columns (:) are preceded by a space in French, but not in English

const translations = {
    general: {
        duplicate: { fr: 'Dupliquer', en: 'Duplicate', },
        download: { fr: 'Télécharger', en: 'Download', },
        share: { fr: 'Partager', en: 'Share', },
        year: { fr: 'an', en: 'year', },
        years: { fr: 'ans', en: 'years', },
        month: { fr: 'mois', en: 'month', },
        months: { fr: 'mois', en: 'months', },
        and: { fr: 'et', en: 'and', },
        french: { fr: 'français', en: 'French', },
        english: { fr: 'anglais', en: 'English', },
        now: { fr: 'Maintenant', en: 'Now', },
        fullColumn: { fr: ' :', en: ':' },
        confirmationMessage: { fr: 'Êtes-vous sûr(e) ?', en: 'Are you sure?' },
    },
    topLeftSection: {
        title: {
            fr: 'Mon espace CV',
            en: 'My CV space',
        },
        anonymousLabel: {
            fr: 'Rendre mon CV anonyme',
            en: 'Make my CV anonymous',
        },
        resumeFirstNameLabel: {
            fr: 'Prénom affiché dans ce CV',
            en: 'First name displayed in this resume',
        },
        resumeLastNameLabel: {
            fr: 'Nom affiché dans ce CV',
            en: 'Last name displayed in this resume',
        },
        introductionLabel: {
            fr: 'Présentation en quelques lignes',
            en: 'Brief presentation',
        },
        hideExperienceLabel: {
            fr: 'Cacher l\'expérience professionnelle',
            en: 'Hide professional experience',
        },
        saveAsDraftLabel: {
            fr: 'Sauvegarder en brouillon',
            en: 'Save as draft',
        },
        saveAndNotifyManagerLabel: {
            fr: 'Sauvegarder et informer le Manager que mon CV est prêt',
            en: 'Save and notify the manager my resume is ready',
        },
        jobTitleLabel: {
            fr: 'Intitulé de poste',
            en: 'Job Title',
        },
        jobTitlePlaceholder: {
            fr: 'Développeur Java',
            en: 'Java developer',
        },
        jobTitleTooltip: {
            fr: 'Définissez le poste / métier visé par le nouveau CV.',
            en: 'Define the target job opportunity',
        },
        resumeLanguageLabel: {
            fr: 'Langue du CV',
            en: 'Resume language',
        },
        resumeNameLabel: {
            fr: 'Nom du CV',
            en: 'Resume Name',
        },
        resumeNamePlaceholder: {
            fr: 'Définissez des mots clés pour ce CV',
            en: 'Define keywords for this resume',
        },
    },
    topRightSection: {
        title: {
            fr: 'Aperçu du CV',
            en: 'CV Preview',
        },
        resumeNameLabel: {
            fr: 'Nom du CV :',
            en: 'CV Name:',
        },
    },
    languageSkillsSection: {
        title: {
            fr: 'Compétences linguistiques',
            en: 'Language skills',
        },
        addLanguageLabel: {
            fr: 'Ajouter une langue',
            en: 'Add language',
        },
        selectLanguageLabel: {
            fr: 'Sélectionnez une langue',
            en: 'Select language',
        },
        selectLevelLabel: {
            fr: 'Sélectionnez un niveau',
            en: 'Select level',
        },
        comprehensionTitle: {
            fr: 'Compréhension',
            en: 'Comprehension',
        },
        oralExpressionTitle: {
            fr: 'Expression orale',
            en: 'Oral expression',
        },
        writingExpressionTitle: {
            fr: 'Écrire',
            en: 'Written',
        },
        listeningComprehensionTitle: {
            fr: 'Compréhension orale',
            en: 'Oral comprehension',
        },
        readingComprehensionTitle: {
            fr: 'Compréhension écrite',
            en: 'Written comprehension',
        },
        continuousOralExpressionTitle: {
            fr: 'Expression orale en continu',
            en: 'Continuous Oral expression',
        },
        oralInteractionTitle: {
            fr: 'Interaction orale',
            en: 'Oral interaction',
        },
    },
    businessSkillsSection: {
        title: {
            fr: 'Compétences & Certifications',
            en: 'Skills & Certifications',
        },
        selectCategoryLabel: {
            fr: 'Sélectionnez une catégorie',
            en: 'Select a category',
        },
        selectCompetenceLabel: {
            fr: 'Sélectionnez une compétence',
            en: 'Select a competence',
        },
        categoryAlreadySelectedLabel: {
            fr: 'Cette catégorie est déjà sélectionnée',
            en: 'This category is already selected',
        },
        competenceAlreadySelectedLabel: {
            fr: 'Cette compétence est déjà sélectionnée',
            en: 'This competence is already selected',
        },
        addCategoryLabel: {
            fr: 'Ajouter catégorie',
            en: 'Add category',
        },
        searchCompetenceLabel: {
            fr: 'Rechercher une compétence',
            en: 'Search for a skill',
        },
        addCompetenceLabel: {
            fr: 'Ajouter compétence',
            en: 'Add skill',
        },
        skillNotFoundLabel: {
            fr: 'Vous ne trouvez pas une compétence ?',
            en: 'Can\'t find a skill?',
        },
    },
    experiencesSection: {
        title: {
            fr: 'Expériences',
            en: 'Experiences',
        },
        addExperienceLabel: {
            fr: 'Ajouter une expérience',
            en: 'Add experience',
        },
        addExperienceHereLabel: {
            fr: 'Ajouter une expérience ici',
            en: 'Add an experience here',
        },
        employerLabel: {
            fr: 'Employeur',
            en: 'Employer',
        },
        activitySectorLabel: {
            fr: 'Secteur d\'activité *',
            en: 'Industry sector *',
        },
        activitySectorTooltip: {
            fr: 'Secteur d\'activité de votre employeur.',
            en: 'Your employer\'s industry sector.',
        },
        notInEuropassTooltip: {
            fr: '* Cette information n\'est pas reprise dans le format Europass.',
            en: '* This information will not appear in the Europass format.',
        },
        inEuropassTooltip: {
            fr: '* Cette information est reprise dans le format Europass.',
            en: '* This information will appear in the Europass format.',
        },
        selectActivitySectorLabel: {
            fr: 'Sélectionnez un secteur',
            en: 'Select industry sector',
        },
        locationLabel: {
            fr: 'Lieu',
            en: 'Location',
        },
        startDateLabel: {
            fr: 'Date de début',
            en: 'Start date',
        },
        endDateLabel: {
            fr: 'Date de fin',
            en: 'End date',
        },
        durationLabel: {
            fr: 'Nombre de jours de la mission',
            en: 'Number of days of the mission',
        },
        jobPositionLabel: {
            fr: 'Poste',
            en: 'Position',
        },
        contractTypeLabel: {
            fr: 'Type de contrat *',
            en: 'Contract type *',
        },
        selectContractTypeLabel: {
            fr: 'Sélectionnez un type de contrat',
            en: 'Select contract type',
        },
        rolesLabel: {
            fr: 'Rôles *',
            en: 'Roles *',
        },
        addRoleLabel: {
            fr: 'Ajouter un rôle',
            en: 'Add role',
        },
        contextLabel: {
            fr: 'Contexte',
            en: 'Context',
        },
        contextTooltip: {
            fr: 'Contexte dans lequel vous avez travaillé.',
            en: 'Context in which you worked.',
        },
        achievementsLabel: {
            fr: 'Réussites',
            en: 'Achievements',
        },
        achievementsTooltip: {
            fr: 'Précisez les résultats positifs que vous avez obtenus.',
            en: 'Specify the positive results you achieved.',
        },
        actionsLabel: {
            fr: 'Actions :',
            en: 'Actions:',
        },
        actionsTooltip: {
            fr: 'Énumérez les tâches, actions, responsabilités quotidiennes.',
            en: 'List daily tasks, actions, responsibilities.',
        },
        addActionLabel: {
            fr: 'Ajouter une action',
            en: 'Add action',
        },
        techEnvironmentTooltip: {
            fr: 'Listez les compétences techniques que vous avez utilisées..',
            en: 'List the technical skills you used.',
        },
        techEnvironmentLabel: {
            fr: 'Environnement technique',
            en: 'Technical environment',
        },
        techEnvironmentPlaceholder: {
            fr: 'Cliquez pour sélectionner',
            en: 'Click to select',
        },
    },
    diplomasSection: {
        title: {
            fr: 'Formations',
            en: 'Education',
        },
        addDiplomaLabel: {
            fr: 'Ajouter une formation',
            en: 'Add education',
        },
        schoolNameLabel: {
            fr: 'École',
            en: 'School',
        },
        fromLabel: {
            fr: 'Date de début',
            en: 'Start date',
        },
        toLabel: {
            fr: 'Date de fin',
            en: 'End date',
        },
        isCurrentLabel: {
            fr: 'En cours',
            en: 'Ongoing',
        },
        educationLevelLabel: {
            fr: 'Niveau',
            en: 'Level',
        },
        selectEducationLevelLabel: {
            fr: 'Sélectionnez une option',
            en: 'Select an option',
        },
        diplomaTitleLabel: {
            fr: 'Intitulé',
            en: 'Title',
        },
    },
    hobbiesSection: {
        title: {
            fr: 'Loisirs',
            en: 'Hobbies',
        },
        addHobbyLabel: {
            fr: 'Ajouter loisir',
            en: 'Add hobby',
        },
    },
    pdf: {
        previewButtonLabel: {
            fr: 'Prévisualiser',
            en: 'Preview',
        },
        duplicateButtonLabel: {
            fr: 'Dupliquer',
            en: 'Duplicate',
        },
        downloadButtonLabel: {
            fr: 'Télécharger',
            en: 'Download',
        },
        shareButtonLabel: {
            fr: 'Partager',
            en: 'Share',
        },
        closeButtonLabel: {
            fr: 'Fermer',
            en: 'Close',
        },
        downloadModalTitle: {
            fr: 'Téléchargement de votre CV',
            en: 'Download your CV',
        },
        downloadModalBody: {
            fr: 'Vous pouvez télécharger votre CV au format PDF en cliquant sur le bouton ci-dessous.',
            en: 'You can download your CV in PDF format by clicking the button below.',
        },
        shareModalTitle: {
            fr: 'Partage de votre CV',
            en: 'Share your CV',
        },
        shareModalBody: {
            fr: 'Vous pouvez partager ce CV en utilisant le lien ci-dessous :',
            en: 'You can share this CV by using the link below:',
        },
        shareModalEmailBodyTemplate: {
            fr: 'Bonjour,\n\nJe souhaitais partager ce CV avec vous. Vous pouvez le consulter ici: {url}\n\nCordialement,\n',
            en: 'Hello,\n\nI would like to share this CV with you. You can find it here: {url}\n\nSincerely,\n',
        },
        loadingLabel: {
            fr: 'Préparation du document...',
            en: 'Preparing document...',
        },
        wordDownloadError: {
            fr: 'Erreur lors de la génération du document Word.',
            en: 'Error while generating the Word document.',
        },
        pdfDownloadError: {
            fr: 'Erreur lors de la génération du document PDF.',
            en: 'Error while generating the PDF document.',
        },
        introductionLabel: {
            fr: 'Je me présente',
            en: 'I introduce myself',
        },
        languageSkillsTitle: {
            fr: 'Compétences linguistiques',
            en: 'Language skills',
        },
        languageSkillsShortTitle: {
            fr: 'Langues',
            en: 'Languages',
        },
        diplomasTitle: {
            fr: 'Éducation et formations',
            en: 'Education and formation',
        },
        diplomasShortTitle: {
            fr: 'Formations',
            en: 'Education',
        },
        businessSkillsTitle: {
            fr: 'Compétences & Certifications',
            en: 'Skills and certifications',
        },
        experiencesTitle: {
            fr: 'Expérience professionelle',
            en: 'Professional experience',
        },
        experiencesShortTitle: {
            fr: 'Expériences',
            en: 'Experiences',
        },
        hobbiesTitle: {
            fr: 'Loisirs',
            en: 'Hobbies',
        },
        nativeLanguagesLabel: {
            fr: 'Langue(s) maternelle(s) :',
            en: 'Mother tongue(s):',
        },
        otherLanguagesLabel: {
            fr: 'Autre(s) langue(s) :',
            en: 'Other language(s):',
        },
        comprehensionHeader: {
            fr: 'Compréhension',
            en: 'Comprehension',
        },
        comprehensionShortHeader: {
            fr: 'Comprendre',
            en: 'Understanding',
        },
        oralExpressionHeader: {
            fr: 'Expression orale',
            en: 'Oral expression',
        },
        oralExpressionShortHeader: {
            fr: 'Parler',
            en: 'Expression',
        },
        writingExpressionHeader: {
            fr: 'Écrire',
            en: 'Written',
        },
        actionsLabel: {
            fr: 'Actions',
            en: 'Actions',
        },
        listeningComprehensionHeader: {
            fr: 'Compréhension orale',
            en: 'Oral comprehension',
        },
        listeningComprehensionShortHeader: {
            fr: 'Oral',
            en: 'Speaking',
        },
        readingComprehensionHeader: {
            fr: 'Compréhension écrite',
            en: 'Written comprehension',
        },
        continuousOralExpressionHeader: {
            fr: 'Expression orale en continu',
            en: 'Continuous Oral expression',
        },
        continuousOralExpressionShortHeader: {
            fr: 'Parler',
            en: 'Expression',
        },
        oralInteractionHeader: {
            fr: 'Interaction orale',
            en: 'Oral interaction',
        },
        isConsultingMissionLabel: {
            fr: 'en mission chez',
            en: 'assignment at',
        },
        workExperienceLabel: {
            fr: 'Expérience professionnelle :',
            en: 'Professional experience:',
        },
        workExperienceTemplate: {
            fr: '{years} an(s) et {months} mois',
            en: '{years} year(s) and {months} month(s)',
        },
        isCurrentLabel: {
            fr: 'En cours',
            en: 'Ongoing',
        },
        numberOfMissionDaysLabel: {
            fr: 'Nombre de jours de la mission :',
            en: 'Number of days of the mission:',
        },
        contextLabel: {
            fr: 'Contexte',
            en: 'Context',
        },
        rolesLabel: {
            fr: 'Roles',
            en: 'Roles',
        },
        achievementsLabel: {
            fr: 'Réussites',
            en: 'Achievements',
        },
        manDaysLabel: {
            fr: 'jh',
            en: 'MD',
        },
        technicalEnvironmentLabel: {
            fr: 'Environnement technique :',
            en: 'Technical environment:',
        },
        employerLabel: {
            fr: 'Employeur',
            en: 'Employer',
        },
        isConsultingLabel: {
            fr: 'en mission chez',
            en: 'assignment at',
        },
        diplomasSchoolLabel: {
            fr: 'École',
            en: 'School',
        },
        missionDurationLabel: {
            fr: 'Nombre de jours de la mission :',
            en: 'Number of days of the mission:',
        },
        languageLevelLabel: {
            fr: 'Niveaux: A1 et A2: utilisateur de base; B1 et B2: utilisateur indépendant; C1 et C2: utilisateur expérimenté',
            en: 'Levels: A1 and A2: basic user; B1 and B2: independent user; C1 and C2: experienced user',
        },
        phoneNumberLabel: {
            fr: 'Numéro de téléphone :',
            en: 'Phone number:'
        },
        emailAddressLabel: {
            fr: 'Adresse électronique :',
            en: 'E-mail address:'
        },
        webSiteLabel: {
            fr: 'Site web :',
            en: 'Website:'
        },
        postalAddressLabel: {
            fr: 'Adresse :',
            en: 'Address:'
        },
    },
    advancedSearch: {
        businessSkills: { 'fr': 'Compétences & Certifications', 'en': 'Skills and certifications', },
        clear: {'fr': 'Tout effacer', 'en': 'Clear search',},
        countryCo: {'fr': 'Pays de rattachement', 'en': 'Country Connection',},
        moreCriteria: {'fr': 'Plus de critères', 'en': 'More criteria',},
        lessCriteria: {'fr': 'Moins de critères', 'en': 'Less criteria',},
        filterBy: { 'fr': 'Filtrer par', 'en': 'Filter by', },
        languages: { 'fr': 'Langues', 'en': 'Languages', },
        levelExp: {'fr': 'Niveau d\'expérience', 'en': 'Experience level',},
        levelForm: {'fr': 'Niveau de formation', 'en': 'Formation level',},
        metier: { 'fr': 'Métier', 'en': 'Business', },
        rechercheAvance: {'fr': 'Aucun résultat trouvé pour les critères de recherche spécifiés.', 'en': 'No results found for the specified search criteria.',},
        result: {'fr': 'Résultat', 'en': 'Result',},
        role: {'fr': 'Rôle', 'en': 'Role',},
        search: { 'fr': 'Recherche avancée', 'en': 'Advanced Search', },
        searchButton: {'fr': 'Chercher', 'en': 'Search',},
        searchBy: { 'fr': 'Recherche par', 'en': 'Search by', },
        sector: {'fr': 'Secteur d\'activité', 'en': 'Industry sector'},
        selectALanguage: { 'fr': 'Sélectionnez une langue', 'en': 'Select a language', },
    },
}

export default translations;
